<template>
    <div>
    <Loader />
    </div>
</template>

<script>

import { mapState } from 'vuex';

export default {
    name: 'QrFamilyRedirect',
    components: {
        Event
    },
    props: ['fid'],
    data() {
        return {
            familyId:null,
            currentFamily:null
        }
    },
    watch: {
        loading(val,oldval) {
             if (val==false)
             {
                this.currentFamily = this.$store.state.familyInfo;
                console.log("Family Info",this.currentFamily.url);
                window.location.href = this.currentFamily.url;
             }
    }
     },
    computed:{
    ...mapState(['loading']),

     },
    mounted() {
        
        //link per il redirect secco sulla pagina della famiglia sul sito Beghelli
        //window.location.href = "https://www.beghelli.it/it/prodotti/illuminazione-di-emergenza/apparecchi-di-emergenza/up-led";


        this.familyId = this.$route.params.fid;
        console.log("Codice famiglia: " +  this.familyId);       
        
        //Si tratta di  QR CODE di famiglia length=26
        /*if (this.productId != null) {
           
           //bisogna decodificare il prodotto
            let origCode = ""+this.productId;
            if (origCode.substr(0,4) == "00AT" || origCode.substr(0,4) == "00TR" ) {
                this.productId = origCode.substr(2,2) + "-" + origCode.substr(4,4);
            } else {
                this.productId = "CT-" + origCode.substr(4,4);
                this.productSerial=origCode.substr(0,4);
            } 
            this.productDate=parseInt(origCode.substr(8,2),16) + "/" + (parseInt(origCode.substr(10,2),16)+"").padStart(2,"0") + "/" + "20"+parseInt(origCode.substr(12,2),16);
            this.productIdSw=""+parseInt(origCode.substr(15,3),16);
            this.productRelSw=""+parseInt(origCode.substr(14,1),16);
            this.productBuild=""+parseInt(origCode.substr(18,4),16);
            this.productPlant=""+parseInt(origCode.substr(22,2),16);
            console.log("productSerial: "+this.productSerial +" productDate:",this.productDate," productPlant:",this.productPlant," productIdSw:",this.productIdSw," productRelSw:",this.productRelSw," productBuild:",this.productBuild);
        }

        //Si tratta di  QR CODE di centrale length=28
        if (this.productId != null && this.productId.length == 28) {

            let origCode = ""+this.productId;
            this.productId = origCode.substr(6,4)
            this.productSerial=origCode.substr(0,6)
            this.productDate=parseInt(origCode.substr(14,2),16) + "/" + (parseInt(origCode.substr(12,2),16)+"").padStart(2,"0") + "/" + "20"+parseInt(origCode.substr(10,2),16);
            this.productIdSw=""+parseInt(origCode.substr(17,3),16);
            this.productRelSw=""+parseInt(origCode.substr(16,1),16);
            this.productBuild=""+parseInt(origCode.substr(20,4),16);
            this.productPlant=""+parseInt(origCode.substr(24,2),16);
            this.productType="cent";
            console.log("productSerial: "+this.productSerial +" productDate:",this.productDate," productPlant:",this.productPlant," productIdSw:",this.productIdSw," productRelSw:",this.productRelSw," productBuild:",this.productBuild);
        }*/
        if (this.currentFamily == null) {
             this.$store.dispatch('loadFamilyInfo', this.familyId);
        }
        else
        {
            console.log("Family Info",this.currentFamily.toString());
        //link per il redirect secco sulla pagina della famiglia sul sito Beghelli
        //window.location.href = "https://www.beghelli.it/it/prodotti/illuminazione-di-emergenza/apparecchi-di-emergenza/up-led";
        }
     }
}

</script>